// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { type SuccessResponse } from "../../api";
import { useGetApi } from "../client";
import { useCallback } from "react";

export function useDeleteKontaktaufnahme(): (
  kontaktaufnahmeId: string
) => Promise<SuccessResponse> {
  const getAPI = useGetApi();
  return useCallback(
    async (kontaktaufnahmeId) =>
      (await getAPI()).kontaktaufnahme.deleteKontaktaufnahme({
        kontaktaufnahmeId,
      }),
    [getAPI]
  );
}
